var _path, _path2, _rect, _circle, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCellPhoneCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 23.4l-4-3.9a2.1 2.1 0 01-.2-2.7 1.9 1.9 0 013-.2l2.6 2.6 6.6-6.6a2 2 0 012.8 2.8l-8 8a1.9 1.9 0 01-2.8 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5h-.5v.527c0 .212 0 .418.023.588a.99.99 0 00.27.592.99.99 0 00.592.27c.17.023.376.023.588.023H13.027c.212 0 .418 0 .588-.023a.99.99 0 00.592-.27.99.99 0 00.27-.592c.023-.17.023-.376.023-.588V2.5H10z",
    stroke: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 2.5,
    width: 11,
    height: 19,
    rx: 1.5,
    stroke: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 1,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13l2 2 5-5",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogIDxwYXRoIGQ9Ik0yMC42LDIzLjRsLTQtMy45YTIuMSwyLjEsMCwwLDEtLjItMi43LDEuOSwxLjksMCwwLDEsMy0uMkwyMiwxOS4ybDYuNi02LjZhMiwyLDAsMCwxLDIuOCwyLjhsLTgsOEExLjksMS45LDAsMCwxLDIwLjYsMjMuNFoiLz4NCiAgPHBhdGggZD0iTTEwIDIuNUg5LjVWM0M5LjUgMy4wMDkwOCA5LjUgMy4wMTgxNSA5LjUgMy4wMjcyQzkuNDk5OTUgMy4yMzkyNCA5LjQ5OTkxIDMuNDQ1MyA5LjUyMjc2IDMuNjE1MjZDOS41NDg1MiAzLjgwNjg2IDkuNjExMjkgNC4wMjU1IDkuNzkyODkgNC4yMDcxMUM5Ljk3NDUgNC4zODg3MSAxMC4xOTMxIDQuNDUxNDggMTAuMzg0NyA0LjQ3NzI0QzEwLjU1NDcgNC41MDAwOSAxMC43NjA4IDQuNTAwMDUgMTAuOTcyOCA0LjVDMTAuOTgxOSA0LjUgMTAuOTkwOSA0LjUgMTEgNC41SDEzQzEzLjAwOTEgNC41IDEzLjAxODEgNC41IDEzLjAyNzIgNC41QzEzLjIzOTIgNC41MDAwNSAxMy40NDUzIDQuNTAwMDkgMTMuNjE1MyA0LjQ3NzI0QzEzLjgwNjkgNC40NTE0OCAxNC4wMjU1IDQuMzg4NzEgMTQuMjA3MSA0LjIwNzExQzE0LjM4ODcgNC4wMjU1IDE0LjQ1MTUgMy44MDY4NiAxNC40NzcyIDMuNjE1MjZDMTQuNTAwMSAzLjQ0NTMgMTQuNSAzLjIzOTI0IDE0LjUgMy4wMjcyQzE0LjUgMy4wMTgxNSAxNC41IDMuMDA5MDggMTQuNSAzVjIuNUgxNEgxMFoiIHN0cm9rZT0id2hpdGUiLz4NCiAgPHJlY3QgeD0iNi41IiB5PSIyLjUiIHdpZHRoPSIxMSIgaGVpZ2h0PSIxOSIgcng9IjEuNSIgc3Ryb2tlPSJ3aGl0ZSIvPg0KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjE5IiByPSIxIiBmaWxsPSJ3aGl0ZSIvPg0KICA8cGF0aCBkPSJNOSAxM0wxMSAxNUwxNiAxMCIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4=";
export { SvgCellPhoneCheck as ReactComponent };